export default function calcCropperCoordinatesFactor({
  coordinates,
  imageSize,
}: {
  imageSize: {
    width: number
    height: number
  }
  coordinates: {
    width: number
    height: number
    top: number
    left: number
  }
}) {
  const factorLeft =
    coordinates.left / (imageSize.width - coordinates.width) || 0
  const factorTop =
    coordinates.top / (imageSize.height - coordinates.height) || 0

  return {
    factorLeft,
    factorTop,
  }
}
